<template>
    <!-- Start Main Content -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Salary Slip Details</h2>
        </div>
        <div class=" ">
            <!-- INITIALIZE CSS CLASS -->
            <div class="hidden">
                <div class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle"></div>
                <div class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"></div>
                <div class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg"></div>
                <div class=" dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon"></div>
                <div class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border"></div>
            </div>
            <!-- INITIALIZE CSS CLASS -->
            <div class="tablejs sr-only size-0"></div>
            <div class="card w-full">
            <!-- BASIC DATA TABLE -->
            <table id="basicDataTable" class="w-full border border-gray-300">
               
                <tbody class="divide-y divide-gray-200">
                    <tr v-for="(item, index) in salslipparticularData" :key="item.id">
                        <td class="w-1/6 p-2 text-left border border-gray-300">From Date:</td>
                        <td class="w-1/6 p-2 text-right border border-gray-300">{{ item.from_date }}</td>
                        <td class="w-1/6 p-2 text-left border border-gray-300">To Date:</td>
                        <td class="w-1/6 p-2 text-right border border-gray-300">{{ item.to_date }}</td>
                    </tr>
                    <tr v-for="(item, index) in salslipparticularData" :key="item.id">
                        <td class="w-1/6 p-2 text-left border border-gray-300">Total Male:</td>
                        <td class="w-1/6 p-2 text-right border border-gray-300">{{ item.total_male }}</td>
                        <td class="w-1/6 p-2 text-left border border-gray-300">Male Amount:</td>
                        <td class="w-1/6 p-2 text-right border border-gray-300">{{ item.male_amt }}</td>
                    </tr>
                    <tr v-for="(item, index) in salslipparticularData" :key="item.id">
                        <td class="w-1/6 p-2 text-left border border-gray-300">Total Female:</td>
                        <td class="w-1/6 p-2 text-right border border-gray-300">{{ item.total_female }}</td>
                        <td class="w-1/6 p-2 text-left border border-gray-300">Female Amount:</td>
                        <td class="w-1/6 p-2 text-right border border-gray-300">{{ item.female_amt }}</td>
                    </tr>
                    <!-- <tr v-for="(item, index) in salslipparticularData" :key="item.id">
                        <td class="w-1/6 p-2 text-left border border-gray-300">Rate:</td>
                        <td class="w-1/6 p-2 text-right border border-gray-300"></td>
                        <td class="w-1/6 p-2 text-left border border-gray-300"></td>
                        <td class="w-1/6 p-2 text-right border border-gray-300">{{ item.gadi_rate }}</td>
                    </tr> -->
                    <tr v-for="(item, index) in salslipparticularData" :key="item.id">
                        <td class="w-1/6 p-2 text-left border border-gray-300">Gadi Bhade:</td>
                        <td class="w-1/6 p-2 text-right border border-gray-300">{{ item.gadi_bhade }}</td>
                        <td class="w-1/6 p-2 text-left border border-gray-300">Gadi Rate:</td>
                        <td class="w-1/6 p-2 text-right border border-gray-300">{{ item.gadi_rate }}</td>
                    </tr>
                    <tr v-for="(item, index) in salslipparticularData" :key="item.id">
                        <td class="w-1/6 p-2 text-left border border-gray-300">Amount:</td>
                        <td class="w-1/6 p-2 text-right border border-gray-300">{{ item.amount }}</td>
                    </tr>

                    <!-- <tr>
                        <td class="px-6 py-4 whitespace-nowrap">Male</td>
                        <td class="px-6 py-4 whitespace-nowrap">{{ salslipparticularData[0]?.total_male }}</td>
                        <td class="px-6 py-4 whitespace-nowrap">{{ salslipparticularData[0]?.male_rate }}</td>
                        <td class="px-6 py-4 whitespace-nowrap">
                            <span>{{ (salslipparticularData[0]?.total_male * salslipparticularData[0]?.male_rate).toFixed(2) }}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="px-6 py-4 whitespace-nowrap">Female</td>
                        <td class="px-6 py-4 whitespace-nowrap">{{ salslipparticularData[0]?.total_female }}</td>
                        <td class="px-6 py-4 whitespace-nowrap">{{ salslipparticularData[0]?.female_rate }}</td>
                        <td class="px-6 py-4 whitespace-nowrap">
                            <span>{{ (salslipparticularData[0]?.total_female * salslipparticularData[0]?.female_rate).toFixed(2) }}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="px-6 py-4 whitespace-nowrap">Gadi Bhade</td>
                        <td class="px-6 py-4 whitespace-nowrap">{{ salslipparticularData[0]?.gadi_bhade }}</td>
                        <td class="px-6 py-4 whitespace-nowrap">{{ salslipparticularData[0]?.gadi_rate }}</td>
                        <td class="px-6 py-4 whitespace-nowrap">
                            <span>{{ (salslipparticularData[0]?.gadi_bhade * salslipparticularData[0]?.gadi_rate).toFixed(2) }}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="px-6 py-4 whitespace-nowrap"><b>Total</b></td>
                        <td class="px-6 py-4 whitespace-nowrap"></td>
                        <td class="px-6 py-4 whitespace-nowrap"></td>
                        <td class="px-6 py-4 whitespace-nowrap"><b>{{ salslipparticularData[0]?.amount }}</b></td>
                    </tr> -->

                </tbody>
            </table>
            </div>
        
            
            <div>
                <button @click="save" id="saveBtn" class="btn b-solid btn-primary-solid px-5 cursor-pointer mt-6 w-1/3 ml-3 mb-3">
                    Mark Accept
                </button>
            </div>
            
            <div class="w-full lg:w-auto lg:ml-2 mt-4 mb-2 ml-2">
                <button @click="exportToExcel" class="w-full lg:w-auto btn btn-primary-solid px-5 mt-2 lg:mt-6 cursor-pointer">
                    Export
                </button>
            </div>


            <div class="card">
                <!-- Static heading -->
                <div id="printable-content">
                    <h1 class="print-only" style="text-align: center;">Zambre Patil Agriculture</h1>
                    <h1 class="print-only" style="text-align: center;">Material Transcation</h1>
                </div>

                <button
                    type="reset"
                    @click="printReceipt"
                    class="btn b-light btn-danger-light btn-sm"
                >
                    Print
                </button>
                </div>



            
            <div class="col-span-full">
                <div class="card p-0">
                    <div class="p-6 space-y-4">
                        <!-- <table id="basicDataTable" class="datatable">
                            <thead>
                                <tr>
                                    <th class="bg-[#B2E8D9]">Employee Name</th>
                                    <th class="bg-[#B2E8D9]">Days</th>
                                    <th class="bg-[#B2E8D9]">Salary</th>
                                    <th class="bg-[#B2E8D9]">Attendance Date</th> 
                                    <th class="bg-[#B2E8D9]">Plot Name</th> 
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr v-for="(item ,index)  in salslipDetailList" :key="item.id">
                                    <td>{{item.employee_name}}</td>
                                    <td>{{item.days}}</td>
                                    <td>{{item.salary}}</td>
                                    <td>{{item.attendance_date}}</td> 
                                    <td>{{item.plot_name}}</td>                                    
                                </tr> 
                            </tbody>
                        </table> -->
                        <table id="basicDataTable" class="datatable min-w-full bg-white divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                                <tr>
                                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Employee Name</th>
                                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" v-for="date in report_dates" :key="date">{{ date }}</th>
                                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Salary</th>
                                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total Present Days</th>
                                    <!-- <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Plot Name</th> -->
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr v-for="(item, index) in salslipDetailList" :key="index">
                                    <td>{{ item.employee_name }}</td>
                                    <td v-for="(day, dayIndex) in item.datahere" :key="dayIndex" class="px-6 py-4 whitespace-nowrap">
                                        <span v-if="day === 'P'" class="plotname">✓ {{ item.plot_name }}</span>
                                        <span v-else>✗</span>
                                    </td>
                                    <td>{{ item.salary }}</td>
                                    <td>{{ item.presenty }}</td>
                                    <!-- <td>{{ item.plot_name }}</td> -->
                                </tr>
                            </tbody>
                        </table>
                         <!-- Save Button -->
                        
                        
                    </div>
                    <!-- <div class="flex-1 ml-3">
                        <button @click="save" id="saveBtn" class="btn b-solid btn-primary-solid px-5 cursor-pointer mt-6 w-full">
                            Mark
                        </button>
                 </div> -->
                    <!-- Prism Code -->
                    <div class="p-6 hidden">
                        <pre>
                            <code class="language-markup">
                                &lt;p>Sorry we can't show the huge data table&lt;/p>
                            </code>
                        </pre>
                    </div>
                    <!-- Prism Code -->
                </div>
            </div>
            <!-- BORDERED SELECTION DELETION DATA TABLE -->
            
        </div>
    </div>
    <!-- End Main Content -->
       <!-- Start Delete Modal -->
    <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-md max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5 text-center">
                    <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                    <div class="mt-5 text-center">
                        <h5 class="mb-1">Are you sure?</h5>
                        <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                        <div class="flex justify-center gap-2 mt-6">
                            <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                            <button type="submit" @click="delete_category" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Delete Modal -->
</template>
<style scoped>
    .plotname{
        font-size: x-small;
    font-weight: 200;
    background: yellow;
    padding: 0px 2px;
    border-radius: 10px;
    }
</style>
<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
name: 'salarySlipDetails',
components: {
 
} ,
mounted(){
     if(this.$route.query.q)
        this.getBasics(this.$route.query.q);
},
data() {
 return {
    salslipDetailList:[],
    salslipparticularData:[],
     datatable:null,
     report_dates:[]
 }
 }, 
methods:{
    
 async getBasics(sal_id) {
       var self=this;
       
         axios.post('getSalSlipDetails', { id: sal_id }).then(function (response) {
                self.salslipDetailList = response.data.salslipDetailList.attendanceData;
                self.report_dates = response.data.salslipDetailList.report_dates;
                 self.salslipparticularData=response.data.salslipparticularData;
                 
                }).then(()=>{ 
                    self.datatable= $(".datatable").DataTable({
                            "paging": true,
                            "ordering": true,  
                            "autoWidth": false });
              
                    });;
  }, 

  exportToExcel() {
        // Prepare the CSV header
        const headers = ["employee_name", "plot_name", "salary", "presenty"];
        const rows = this.salslipDetailList.map(item => [
            item.employee_name,
            item.plot_name,
            item.salary,
            item.presenty,
        ]);

        // Combine headers and rows into a CSV string
        const csvContent = [headers, ...rows]
            .map(row => row.map(value => `"${value}"`).join(","))
            .join("\n");

        // Create a Blob from the CSV content
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);

        // Trigger a download
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "salaryslipDetails.csv");
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },

  async save() {
   
        // Collect selected `id`s from salslipDetailList
        const attendanceData = this.salslipDetailList.map(item => ({
            id: item.id, // Add the id of each item
        }));
        const sal_id = this.$route.query.q;
        // Make an API request to save the attendance data
        const response = await axios.post('savemark', { attendance: attendanceData,sal_id });

        if (response) {
            this.$swal("Mark successfully!");
        } else {
            this.$swal("Failed to Mark: " + response.data.message);
        }
},




printReceipt() {
            $('.datatable').DataTable().destroy(); 
             window.print();
    },



}
}
</script>

<style scoped>
    tfoot{
        background: antiquewhite;
        font-size: medium;
        font-weight: 800;
    }
    tfoot td{
        height: 35px;
    }
    .print-only {
        display: none;
    }
    
    @media print {
        .print-only {
            display: block; /* Show elements for print */
            text-align: center; /* Center alignment as needed */
            font-size: 16px; /* Font size adjustments if needed */
        }
    }
    
    
    @media print {
        /* Hide unnecessary elements */
        button, select, input, h2, .header_class, .header, .card-title {
            display: none !important;
        }
        
    
        /* Adjust the layout */
        body {
            margin: 0;
            padding: 0;
            font-family: Arial, sans-serif;
        }
    
        /* Receipt container */
        .receipt-container, #printable-content {
            width: 100%;
            padding: 10mm;
            margin: auto;
            border: 1px solid #000;
        }
    
        /* Add a border and spacing to the table */
        table {
            width: 100%;
            border-collapse: collapse;
        }
    
        table th, table td {
            border: 1px solid #ddd;
            padding: 8px;
            text-align: left;
            font-size: 12px;
            color: black !important; 
        }
    
        
        table th {
            background-color: #f2f2f2;
            font-weight: bold;
            color: black!important;
        }
    
        /* Center titles */
        h1, h2 {
            text-align: center;
            margin: 0 0 10px;
            font-size: 16px;
            font-weight: bold;
        }
    
        /* Add company branding details */
        #printable-content {
            text-align: center;
        }
    
        #printable-content h1 {
            font-size: 20px;
        }
    
        /* Add spacing between sections */
        .section {
            margin-bottom: 20px;
        }
    
        /* Performance container styling */
        .performance-container {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
        }
    
        .performance-box {
            flex: 1;
            padding: 5px;
            margin: 0 5px;
            border: 1px solid #ddd;
            font-size: 12px;
            text-align: center;
        }
    
        .performance-box.best {
            background-color: #c8e6c9;
        }
    
        .performance-box.good {
            background-color: #bbdefb;
        }
    
        .performance-box.average {
            background-color: #ffe0b2;
        }
    }
    
      
        .salary_input{
            padding: 5px;
            width: 70px;
        }
        .plotname{
            font-size: x-small;
        font-weight: 200;
        background: yellow;
        padding: 0px 2px;
        border-radius: 10px;
        }
    
        .performance-container {
          display: flex;
          gap: 20px;
        }
        .performance-box {
          padding: 1px;
          border-radius: 8px;
          color: white;
          text-align: center;
          font-weight: bold;
          width: 80px;
        }
        
        .Best1 {
          background-color: green;
        }
        .Good1 {
          background-color: blue;
        }
        .Average1 {
          background-color: orange;
        }
    
        .best {
      color: green;
    }
    .good {
      color: blue;
    }
    .average {
      color: orange;
    }
    </style>
    










<style>



@media print {
    button, select, input, h2, .header_class, .header, .card-title,select,label,.select2 {
        display: none !important;
    }
    

}

    .suggestions-list{
    line-height: 16px;
    background: bisque;
    padding: 10px;
}
.suggestions-list li{
    padding-top: 5px;
    border-bottom: 0.5px solid gray;
}
</style>